(function () {
  'use strict';

  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;

    var idField = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[data-quantity-input]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    var loader = addBtn ? addBtn.querySelector('[data-loader]') : null;
    var buyNowBtn = form.querySelector('[data-buy-now-button]');
    var errorWrapper = form.querySelector('[data-error-message-wrapper]');
    var errorMessage = form.querySelector('[data-error-message]');
    var addedBanner = root.querySelector('[data-added-banner]');

    var upsell = root.querySelector('[data-upsell]');
    var upsellCheckbox = upsell ? upsell.querySelector('[data-upsell-check]') : null;
    var upsellAction = upsell ? upsell.querySelector('[data-upsell-action]') : null;

    // ---- Upsell checkbox toggle (visual state only; cart logic below) ----
    function isUpsellChecked() {
      return upsell ? upsell.classList.contains('is-checked') : false;
    }

    function updateAddButtonLabel() {
      if (!addBtnText || !upsell) return;
      if (addBtn && addBtn.getAttribute('aria-disabled') === 'true') return;
      addBtnText.textContent = isUpsellChecked()
        ? upsell.dataset.bothAddLabel
        : upsell.dataset.mainAddLabel;
    }

    function toggleUpsell() {
      if (!upsell) return;
      var next = !isUpsellChecked();
      upsell.classList.toggle('is-checked', next);
      if (upsellCheckbox) upsellCheckbox.setAttribute('aria-checked', next ? 'true' : 'false');
      if (upsellAction) {
        upsellAction.textContent = next
          ? upsell.dataset.upsellAddedLabel
          : upsell.dataset.upsellActionLabel;
      }
      updateAddButtonLabel();
    }

    if (upsellCheckbox) {
      upsellCheckbox.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        toggleUpsell();
      });
      upsellCheckbox.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
          evt.preventDefault();
          toggleUpsell();
        }
      });
      updateAddButtonLabel();
    }

    // ---- Click anywhere on the upsell card toggles it, EXCEPT the
    // image/title/description link, which navigates to the add-on's
    // own product page instead. ----
    if (upsell) {
      upsell.addEventListener('click', function (evt) {
        if (evt.target.closest('a')) return;
        if (evt.target.closest('[data-upsell-check]')) return;
        toggleUpsell();
      });
    }

    // ---- Notify Horizon's own native cart components (header cart-icon,
    // cart-items-component in the drawer/cart page) that the cart changed.
    // Both listen for the theme's 'cart:update' document event; since we
    // don't include rendered section HTML in the event detail, they each
    // fall back to re-fetching and re-rendering themselves — this is what
    // keeps the drawer/cart page and header badge in sync without a page
    // reload, since our add-to-cart request bypasses their own component. ----
    function notifyNativeCartUpdate() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'v2-pdp-add-to-cart',
              data: { itemCount: cart.item_count, source: 'v2-pdp-add-to-cart' }
            }
          }));
        })
        .catch(function () {});
    }

    function buildItems() {
      var mainVariantId = idField ? idField.value : null;
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      if (!mainVariantId) return null;

      var items = [{ id: mainVariantId, quantity: quantity }];
      if (isUpsellChecked() && upsell) {
        items.push({ id: upsell.dataset.upsellVariantId, quantity: quantity });
      }
      return items;
    }

    // ---- Unified add-to-cart: handles both the plain case and the
    // upsell-checked case through a single, guaranteed-success-tracked
    // request, so the "Added to bag" confirmation is always accurate. ----
    function setLoading(isLoading) {
      if (addBtn) addBtn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      if (addBtnText) addBtnText.classList.toggle('hide', isLoading);
      if (loader) loader.classList.toggle('hide', !isLoading);
    }

    function showAdded() {
      if (!addedBanner) return;
      addedBanner.classList.remove('hide');
      window.clearTimeout(addedBanner._hideTimer);
      addedBanner._hideTimer = window.setTimeout(function () {
        addedBanner.classList.add('hide');
      }, 4000);
    }

    // ---- Reuse Horizon's own native add-to-cart animation: the flying
    // product image toward the cart icon (<fly-to-cart>, already defined
    // and styled globally by the theme) plus the checkmark-burst morph
    // on the button itself (driven entirely by global CSS keyed off
    // [data-added="true"], via the .add-to-cart-button/.add-to-cart-text/
    // .add-to-cart__added classes already added to this button's markup). ----
    function animateAddToCart(button) {
      if (!button) return;

      if (window.customElements && customElements.get('fly-to-cart')) {
        var cartIcon = document.querySelector('.header-actions__cart-icon');
        var image = button.getAttribute('data-product-media');
        if (cartIcon && image) {
          var flyEl = document.createElement('fly-to-cart');
          flyEl.classList.add('fly-to-cart--main');
          flyEl.style.setProperty('background-image', 'url(' + image + ')');
          flyEl.style.setProperty('--start-opacity', '0');
          flyEl.source = button;
          flyEl.destination = cartIcon;
          document.body.appendChild(flyEl);
        }
      }

      button.dataset.added = 'true';
      window.clearTimeout(button._addedResetTimer);
      button._addedResetTimer = window.setTimeout(function () {
        button.removeAttribute('data-added');
      }, 800);
    }

    function showError(message) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = message || 'Something went wrong. Please try again.';
        errorWrapper.classList.remove('hide');
      }
    }

    form.addEventListener(
      'submit',
      function (evt) {
        evt.preventDefault();
        if (errorWrapper) errorWrapper.classList.add('hide');
        if (addedBanner) addedBanner.classList.add('hide');

        var items = buildItems();
        if (!items) return;

        setLoading(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            setLoading(false);
            showAdded();
            animateAddToCart(addBtn);
            notifyNativeCartUpdate();
          })
          .catch(function (err) {
            setLoading(false);
            showError(err && err.description);
          });
      },
      true // capture phase — this is the only submit handler for this form
    );

    // ---- Sticky add-to-cart bar: shown once the real add-to-cart
    // button has scrolled out of view above the viewport. Its button
    // just re-triggers the real submit button so all existing cart /
    // upsell logic above stays the single source of truth. ----
    var stickyBar = root.querySelector('[data-sticky-bar]');
    if (stickyBar && addBtn) {
      var stickyAddBtn = stickyBar.querySelector('[data-sticky-add]');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function () {
          addBtn.click();
        });
      }

      // Plain scroll/resize check rather than IntersectionObserver — this
      // keeps behavior simple and predictable across contexts (including
      // the Shopify theme editor's preview iframe).
      var tickingSticky = false;
      function updateStickyVisibility() {
        tickingSticky = false;
        var rect = addBtn.getBoundingClientRect();
        var scrolledPast = rect.bottom < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
      }
      function onStickyScroll() {
        if (tickingSticky) return;
        tickingSticky = true;
        window.requestAnimationFrame(updateStickyVisibility);
      }
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      window.addEventListener('resize', onStickyScroll);
      updateStickyVisibility();
    }

    // ---- Buy it now: add to cart, then go straight to checkout ----
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (errorWrapper) errorWrapper.classList.add('hide');

        var items = buildItems();
        if (!items) return;

        buyNowBtn.setAttribute('aria-disabled', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            buyNowBtn.removeAttribute('aria-disabled');
            showError(err && err.description);
          });
      });
    }
  });
})();
